<template>
			<div id="page-content" class="supplier-sidebar">
			
				<div id="myproduct" class="component-padding">
					
					<p class="header-type-e">Product: 6SGHA14</p>
					
					<div id="ex1" style="overflow: hidden;">
						<div class="col-md-4">
							<img style="width: 100%; height: auto;" src="static/images/j.jpeg" />
						</div>
						
						<div class="col-md-4 product-data">
							<h2 >Product Info</h2>
							<p><strong>Description</strong></p>
							<p class="text-justify">Chase red laser dot eat half my food and ask for more. Make muffins if it fits, i sits meow meow chase red.</p>
							<p><strong>Price</strong> Php 140.00</p>
						
						</div>
						
						<div class="col-md-4 product-data">
							<h2 >Product Specs</h2>
							<ul class="product-specs">
								<li><strong>Box Dimension (cm)</strong> 7 x 7 x 7</li>
								<li><strong>Item Dimension (cm)</strong> 7 x 7 x 7</li>
								<li><strong>Design</strong> Classic</li>
								<li><strong>Materials</strong> Acrylic</li>
								<li><strong>Socket Type</strong> E12</li>
								<li><strong>Finish</strong> Antique Brass</li>
								<li><strong>Category</strong> Bulbs</li>
								<li><strong>Place</strong> Aisle</li>
								<li><strong>Ceiling</strong> High Ceiling</li>
								<li><strong>I/O</strong> Indoor</li>
								<li><strong>LED</strong> LED Capable</li>
							</ul>
						</div>
						
						
					</div>
					
					<div style="clear: both; padding-bottom: 40px;"></div>
				
				</div>
				
			</div>
</template>

<script>
	export default{
		data(){
			return{

			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		}
	}
</script>


// WEBPACK FOOTER //
// SupplierProduct.vue?06b06a0c